<div class="projects-round-testlist-container">
  <div class="rounds-workflow">
    @for (round of testRounds; track round; let roundIndex = $index) {
      <div
        class="round-section col-4"
        [class.active-round]="round.isActive"
        [class.completed-round]="isRoundCompleted(roundIndex)">
        <div class="round-header">
          <h4 class="round-title">
            {{ round.name }}
            @if (hasIssues(round.id)) {
              <span class="issue-count">
                ({{ getIssueCount(round.id) }} issues)
              </span>
            }
          </h4>
        </div>
        <div class="round-states">
          @for (state of round.states; track state; let stateIndex = $index) {
            <div
              class="state-container">
              <button
                type="button"
                [class]="getButtonClass(state)"
                [disabled]="isButtonDisabled(state)"
                (click)="onStateClick(round.id, state.id)"
                class="state-button">
                {{ state.name }}
              </button>
              @if (state.status === 'completed' && state.operatorName && state.completedAt) {
                <div
                  class="operator-info">
                  <div class="operator-name">{{ state.operatorName }}</div>
                  <div class="completion-time">{{ state.completedAt | date:'yyyy-MM-dd HH:mm:ss' }}</div>
                </div>
              }
            </div>
          }
        </div>
        <div class="round-description">
          @switch (round.id) {
            @case ('round1') {
              <div>
                During the first round of check, the Client can fix the issues found.
              </div>
            }
            @case ('client-declaration') {
              <div>
              </div>
            }
            @case ('round2') {
              <div>
                If the issues found from our Tester team are more than 10% of the total of the first round, the
                project will be stopped for an extra proposal and proceed after confirmation from the Client
              </div>
            }
          }
        </div>
      </div>
    }
  </div>
</div>
